module.exports = (window.__publicpath__ || __webpack_public_path__) + "static/media/SquareSolidSmall.ee0390d2.svg";